import { SxProps, Theme } from '@mui/material';

import { themeColors } from '@/config/theme/themeColors.ts';

export const appPageHeaderStyles: SxProps<Theme> = {
  justifyContent: 'center',
  minWidth: 0,
};

export const appPageHeaderBreadcrumbsStyles: SxProps<Theme> = {
  '& .MuiBreadcrumbs-ol': {
    alignItems: 'baseline',
  },
  color: themeColors.greyDark,
};

export const appPageHeaderSeparatorStyles: SxProps<Theme> = {
  color: themeColors.greyDark,
  fontSize: 14,
};

export const appPageHeaderLinkStyles: SxProps<Theme> = {
  '&:hover': {
    color: themeColors.accentColorDark,
  },
  color: themeColors.greyDark,
  textDecoration: 'none',
};

export const appPageHeaderParentStyles: SxProps<Theme> = {
  color: themeColors.greyDark,
};

export const appPageHeaderCurrentStyles: SxProps<Theme> = {
  color: themeColors.accentColor,
  lineHeight: 1.3,
};

export const appPageHeaderDescriptionStyles: SxProps<Theme> = {
  color: 'text.secondary',
  display: { md: 'block', xs: 'none' },
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
